export class CustomPageBlockError extends Error {
    constructor(message: string) {
        super(message)
    }
}